import { module } from 'angular';
import 'ng-img-crop/compile/minified/ng-img-crop.js';
import 'ng-img-crop/compile/minified/ng-img-crop.css';
import { CropImageModalComponent } from './crop-image-modal.component';
import { CropImageService } from './services/crop-image.service';

export const CropImageModalModule = module('app.components.modals.crop-image-modal', [
  'ngImgCrop'
])
  .component('cropImageModal', CropImageModalComponent)
  .service(CropImageService.name, CropImageService)
  .name;



// WEBPACK FOOTER //
// ./app/components/modals/crop-image-modal/crop-image.modal.module.ts